import rules from "../../Data/Rules"
import store from "../../veux/store";
import functions from "../../Data/Functions"


// Use the following examples of URL
// Portal=PAY&Entity=292&Type=Organisation
// Portal=PAY&Entity=841&Type=Team
// Entity is the team or Organisations code
// Type can be either Team or Organisation to look up in Products

let Products

// Product Step Schema
let Product_Step = {
    stepno: 1,
    title: 'Product',
    valid: true,
    information: ``,
    Schema: {
        Product: {
            type: "select",
            label: 'Please select a Product: ',
            outlined: true,
            row: true,
            dense: true,
            hidden: false,
            returnObject: true,
            itemText: 'Name',
            col: 12,
            rules: [rules.requiredMsg('Product Selection is Required')],
            class: 'mx-1 px-1',
            items: Products,
            onInput: (ev, portal) => {
                portal.Model.ProductDesc = ev.data.Product.Name
                portal.Model.Amount = ev.data.Product.Price.toFixed(2)
                ev.schema.Team.Role = ev.data.Product.Role
                ev.schema.Team.Association = ev.data.Product.Association
                ev.schema.Team.OUG.Type = ev.data.Product.Type
                ev.data.Team = {
                    Detail: ev.data.Product.EntityName,
                    Code_id: ev.data.Product.Team_id,
                    Association: ev.data.Product.Association
                }
            },
            OUG: { Products: true }
        },
        Team: {
            "type": "text",
            "label": "Which Club are you registering for?",
            outlined: true,
            dense: true,
            hidden: true,
            rules: [],
            class: 'mx-1 px-1',
            Role: 13,
            OUG: { Contact_Roles: true, Type: "Teams" }
        },
    },
}

export default {

    LoadSchema: async (Step, Entity, Type) => {
        Products = await functions.GetProducts(Entity, Type, true);
        Product_Step.Schema.Product.items = Products
        Product_Step.stepno = Step
        return Product_Step
    },

}